/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';

import styles from '../styles.module.css';

type IconDatocmsRenderedProps = {
  internalLink: string;
  externalLink: string;
  image: { url: string; alt: string };
  className?: string;
};

export const IconDatocmsRendered = ({ internalLink, externalLink, image, className }: IconDatocmsRenderedProps) => {
  if (internalLink || externalLink) {
    return (
      <div className={className}>
        <Link href={externalLink || internalLink} target={internalLink ? '_self' : '_blank'}>
          <img src={image.url} className={styles.responsiveImage} alt={image.alt} />
        </Link>
      </div>
    );
  }
  return (
    <div className={className}>
      <img src={image.url} className={styles.responsiveImage} alt={image.alt} />
    </div>
  );
};
